import { render, staticRenderFns } from "./TextElementPublish.vue?vue&type=template&id=69b7a32e&"
import script from "./TextElementPublish.vue?vue&type=script&lang=ts&"
export * from "./TextElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./TextElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports